import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Privacy Policy</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">Encrypted User Architecture Asset Directives</p>
      
      <div className="space-y-6 text-xs leading-relaxed font-serif text-zinc-700">
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">1. Collected Information Parameters</h4>
          <p>Modische Kledings handles user profiles with care. We capture core data assets needed for logistics execution during checkout, including full legal names, contact delivery cell numbers, postal shipping addresses, and electronic email tracking logs.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">2. Transaction Security Shields</h4>
          <p>Your payment information is never captured, stored, or processed by our local database clusters. Real-time authorizations are sent instantly to **Razorpay’s token secure checkout API**, operating under robust, world-class encryption security layers.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">3. Cookie Data Collections</h4>
          <p>We use localized browser storage hooks (`localStorage`) to retain your secure account tokens and speed up login workflows. These keys can be instantly cleared by terminating your dashboard session via the log out menu links.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;